import React from 'react';
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";

function LoginPage() {
  const { instance } = useMsal();

  const handleLogin = () => {
    instance.loginRedirect(loginRequest).catch(e => {
      console.error(e);
    });
  };

  return (
    <div>
      <h2>Document Approval Login</h2>
      <p>Please log in with your company account.</p>
      <button onClick={handleLogin}>Log In</button>
    </div>
  );
}

export default LoginPage;